import {
  GET_BRANCH_DETAILS_PROVIDER,
  GET_BRANCH_DETAILS_PROVIDER_FAILURE,
  GET_BRANCH_DETAILS_PROVIDER_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getBranchDetailsProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BRANCH_DETAILS_PROVIDER:
      return { ...state, loading: true };
    case GET_BRANCH_DETAILS_PROVIDER_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_BRANCH_DETAILS_PROVIDER_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getBranchDetailsProviderReducer;
